import { Box, Center, Flex, SimpleGrid, Stack, Skeleton } from "@chakra-ui/react";

const Chunk = ({ width = "100%", height = "18px" }) => <Skeleton height={height} width={width} borderRadius="md" />;

const RightCard = ({ hasButtons }: { hasButtons?: boolean }) => (
    <Box bg="gray.50" borderRadius="lg" p={5} boxShadow="xs">
        <Stack gap={4}>
            <Chunk width="40%" height="20px" />
            <Chunk width="80%" height="16px" />
            <Chunk width="65%" height="16px" />

            {hasButtons && (
                <SimpleGrid columns={2} gap={4} pt={2}>
                    <Chunk height="42px" />
                    <Chunk height="42px" />
                </SimpleGrid>
            )}
        </Stack>
    </Box>
);

const BottomSummaryCard = () => (
    <Box bg="gray.50" borderRadius="lg" p={5} boxShadow="xs">
        <Stack gap={3}>
            <Chunk width="30%" height="18px" />
            <Chunk width="90%" height="14px" />
            <Chunk width="95%" height="14px" />
            <Chunk width="85%" height="14px" />
            <Chunk width="70%" height="14px" />
        </Stack>
    </Box>
);

export const InvoicePageSkeleton = () => (
    <Center>
        <Box m={{ base: "1rem", lg: "1.5rem" }} minW={{ base: "100%", lg: "70rem" }} w="80rem" alignItems="center">
            <Stack gap={6}>
                {/* Header */}
                <Flex w="100%" justifyContent="space-between" alignItems="center" px="1rem" py="0.5rem">
                    <Flex alignItems="center" gap="1rem">
                        <Chunk width="260px" height="32px" /> {/* title */}
                        <Chunk width="110px" height="26px" /> {/* status badge */}
                    </Flex>

                    <Flex alignItems="center" gap="1rem">
                        <Chunk width="140px" height="18px" /> {/* SavedStatuses */}
                        <Chunk width="160px" height="36px" /> {/* delete button */}
                    </Flex>
                </Flex>

                {/* Main content – where OneStepInvoice renders */}
                <Box px="1rem" pb="3rem">
                    {/*eslint-disable-next-line no-magic-numbers*/}
                    <SimpleGrid columns={{ base: 1, lg: 12 }} gap={6}>
                        {/* LEFT SIDEBAR */}
                        <Box gridColumn={{ base: "span 12", lg: "span 4" }}>
                            <Box
                                bg="white"
                                borderRadius="lg"
                                boxShadow="xs"
                                borderWidth="1px"
                                borderColor="gray.100"
                                p={4}
                            >
                                <Stack gap={5}>
                                    {/* Top light box */}
                                    <Box bg="gray.50" borderRadius="md" p={4}>
                                        <Stack gap={2}>
                                            <Chunk width="65%" height="14px" />
                                            <Chunk width="85%" height="12px" />
                                            <Chunk width="75%" height="12px" />
                                            <Chunk width="55%" height="12px" />
                                            <Chunk width="40%" height="12px" />
                                        </Stack>
                                    </Box>

                                    {/* Divider */}
                                    <Box height="1px" bg="gray.200" />

                                    {/* Middle list */}
                                    <Stack gap={3}>
                                        <Chunk width="70%" height="12px" />
                                        <Chunk width="60%" height="12px" />
                                        <Chunk width="75%" height="12px" />
                                        <Chunk width="55%" height="12px" />
                                        <Chunk width="68%" height="12px" />
                                        <Chunk width="50%" height="12px" />
                                    </Stack>

                                    {/* Divider */}
                                    <Box height="1px" bg="gray.200" />

                                    {/* Bottom small section */}
                                    <Stack gap={2}>
                                        <Chunk width="40%" height="12px" />
                                        <Chunk width="55%" height="32px" />
                                    </Stack>
                                </Stack>
                            </Box>
                        </Box>

                        {/* RIGHT COLUMN */}
                        <Stack gap={5} gridColumn={{ base: "span 12", lg: "span 8" }}>
                            <RightCard />
                            <RightCard />
                            <RightCard />
                            <RightCard hasButtons />
                            <RightCard />
                            <RightCard />
                            <RightCard hasButtons />

                            <BottomSummaryCard />
                        </Stack>
                    </SimpleGrid>
                </Box>
            </Stack>
        </Box>
    </Center>
);
